import { Event } from '@/interfaces/event';
import { EventResource, eventResource } from '@/resources/event.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł Zdarzeń
 *
 * @export
 * @class EventModule
 * @extends {EntityModule<Event, EventResource>}
 */
export class EventModule extends EntityModule<Event, EventResource> {
  constructor() {
    super(eventResource);
  }
}

export default new EventModule();
